module.exports = __webpack_public_path__ + "static/media/remember_08.f085c881.png";